import { BlocksSearchForm } from 'blocks-nextjs/blocks-web-components/components/search-form/search-form';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';
export const CatSearchForm = createComponent({
    react: React,
    tagName: 'cat-search-form',
    elementClass: BlocksSearchForm,
    events: {
        onBlChange: 'bl-change',
        onBlSelect: 'bl-select',
        onBlMobileOverlayClose: 'bl-mobile-overlay-close',
        onBlMobileOverlayOpen: 'bl-mobile-overlay-open',
        onBlSearch: 'bl-search',
        onBlSearchClose: 'bl-search-close',
        onBlSearchOpen: 'bl-search-open',
        onBlScrollEnd: 'bl-scroll-end'
    }
});
